const CONSENT_KEY = 'cookieConsent'
const CONSENT_VERSION = '1.0'

interface ConsentData {
  necessary: true
  functionality: boolean
  analytics: boolean
  timestamp: number
  version: string
}

export const useCookieConsent = () => {
  const hasConsent = useState<boolean>('cc-given', () => false)
  const consentData = useState<ConsentData | null>('cc-data', () => null)
  const showSettings = useState<boolean>('cc-settings', () => false)

  const loadConsent = () => {
    if (typeof window === 'undefined') return
    try {
      const stored = localStorage.getItem(CONSENT_KEY)
      if (stored) {
        const parsed: ConsentData = JSON.parse(stored)
        if (parsed.version === CONSENT_VERSION) {
          consentData.value = parsed
          hasConsent.value = true
        }
      }
    } catch {}
  }

  const saveConsent = (functionality: boolean, analytics: boolean) => {
    const data: ConsentData = {
      necessary: true,
      functionality,
      analytics,
      timestamp: Date.now(),
      version: CONSENT_VERSION
    }
    if (typeof window !== 'undefined') {
      localStorage.setItem(CONSENT_KEY, JSON.stringify(data))
    }
    consentData.value = data
    hasConsent.value = true
    showSettings.value = false
  }

  const acceptAll = () => saveConsent(true, true)
  const acceptNecessary = () => saveConsent(false, false)

  const openSettings = () => { showSettings.value = true }
  const closeSettings = () => { showSettings.value = false }

  const hasCategory = (category: keyof Omit<ConsentData, 'timestamp' | 'version'>): boolean => {
    return consentData.value?.[category] === true
  }

  return {
    hasConsent,
    consentData,
    showSettings,
    loadConsent,
    acceptAll,
    acceptNecessary,
    saveConsent,
    openSettings,
    closeSettings,
    hasCategory
  }
}
